import React, { useMemo } from 'react'

import { useNavigation } from 'redux/hooks/NavigationMenuStore'
import { useNavigationActions } from 'redux/actions/NavigationMenu'
import { useAccountSettings } from 'redux/hooks/SignedInAccount'
import { useTranslation } from 'language/translator'

import NavigationMenu from 'components_new/molecules/NavigationMenu'
import { TNavigationItem } from 'components_new/molecules/NavigationItem'

import { RESOURCES_NAV_MENU_ID } from 'components_new/organisms/Navbar/lib'
import { DASHBOARD_COLOR, REPORT_COLOR } from 'utils/colors'

const GroupsNavigation = () => {
  const { open, expandedItems } = useNavigation()
  const { toggleNavigationItem } = useNavigationActions()
  const { allowAccess } = useAccountSettings()

  const { t } = useTranslation()

  const items: TNavigationItem[] = useMemo(() => {
    return [
      {
        activePattern: ['/resources', '/resources/folders/*'],
        excludeActiveQueryParam: ['type'],
        icon: { name: 'Resources' } as const,
        href: '/resources',
        title: t('resources', 'all_resources')
      },
      {
        activePattern: [
          '/resources?type=dashboard',
          '/resources/folders/*?type=dashboard',
          '/dashboards/*'
        ],
        icon: { color: DASHBOARD_COLOR, name: 'Dashboards' } as const,
        href: '/resources',
        search: '?type=dashboard',
        title: t('global', 'dashboards')
      },
      ...(allowAccess.allow_reports
        ? [
            {
              activePattern: [
                '/resources?type=report',
                '/resources/folders/*?type=report',
                '/reports/*'
              ],
              icon: { color: REPORT_COLOR, name: 'Reports' } as const,
              href: '/resources',
              search: '?type=report',
              title: t('global', 'reports')
            }
          ]
        : []),
      {
        activePattern: '/templates*',
        icon: { name: 'Templates' } as const,
        href: '/templates',
        title: t('global', 'templates')
      }
    ]
  }, [allowAccess.allow_reports])

  return (
    <NavigationMenu
      collapsed={{
        activePattern: '/resources*',
        href: '/resources',
        iconName: 'Resources',
        value: !open
      }}
      expandedItems={expandedItems}
      id={RESOURCES_NAV_MENU_ID}
      items={items}
      title={t('global', 'resources')}
      toggleNavigationItem={(id) => {
        toggleNavigationItem(id)
      }}
    />
  )
}

export default GroupsNavigation
